import { GetQueryString } from "../utils";
import { MasterSync, RationaleTemplatePayload } from "../models/Master";
import API from "./api";
import { DisciplineSearch } from "../models/Service";
import { NppesPayloadData } from "../models/PhysicianDetails";

export const GetMasterCallOutcome = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/CallOutcomes`);

export const GetHealthProgram = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/healthprogram`);

export const GetCareCoordinationProgram = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/carecoordination`);

export const GetNonCoveredService = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/NonCoveredServices`);

export const GetOrderingSource = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/OrderingSource`);

export const GetOrderAcceptor = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/OrderAcceptor`);

export const GetDisciplines = (configUrl: string, payload?: DisciplineSearch) =>
  API.getMaster(
    `${configUrl}api/master/Disciplines?${payload && GetQueryString(payload)}`
  );

export const GetCareType = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/CareTypes`);

export const GetPastMedicalHistory = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/Diseases`);

export const GetPsychologicalHistory = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/PsychologicalDiseases`);

export const GetIcdCodeTypeData = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/DiagnosisType`);

export const GetDocumentType = (
  configUrl: string,
  excludeLetter: boolean,
  isForFilter: boolean
) =>
  API.getMaster(
    `${configUrl}api/master/DocumentType?excludeLetter=${excludeLetter}&isForFilter=${isForFilter}`
  );

export const GetReferralServiceStatusType = (
  configUrl: string,
  requiredIncompleteOption: boolean
) =>
  API.getMaster(
    `${configUrl}api/master/ReferralServiceStatus?requiredIncomplete=${requiredIncompleteOption}`
  );

export const GetServiceStatusReasonMaster = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/StatusReasons`);

export const GetDisciplineType = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/ServiceType`);

export const GetServiceStatusReason = (configUrl: string, serviceId: number , isRetro : boolean, serviceRequestId?:number ) =>
  API.getMaster(`${configUrl}api/master/StatusReason/${serviceId}?serviceRequestId=${serviceRequestId?serviceRequestId:null}&isBcbsTnRetro=${isRetro}`);

export const GetDocumentSource = (configUrl: string, isForFilter: boolean) =>
  API.getMaster(`${configUrl}api/master/DocumentReview?isForFilter=${isForFilter}`);

export const GetDocumentCreatedBy = (configUrl: string, searchText: string) =>
  API.getMaster(`${configUrl}api/master/UserDetails?searchText=${searchText}`);

export const GetAuthorizationStatusMaster = (configUrl: any) =>
  API.getMaster(`${configUrl}api/master/ReferralStatus`);

export const GetReferralSourceMaster = (
  configUrl: any,
  serviceRequestTypeId: number
) =>
  API.getMaster(
    `${configUrl}api/master/ReferralSourceFacility/${serviceRequestTypeId}`
  );

export const GetStaffingStatusMaster = (configUrl: any) =>
  API.getMaster(`${configUrl}api/master/StaffingStatus`);

export const GetDisciplineTemplateMaster = (
  configUrl: any,
  payload: RationaleTemplatePayload
) =>
  API.getMaster(
    `${configUrl}api/master/RationaleTemplate/${
      payload.serviceRequestDisciplineId
    }?${GetQueryString(payload)}`
  );

export const GetDischargeReasonMaster = (configUrl: any) =>
  API.getMaster(`${configUrl}api/master/DischargeReason`);

export const GetDiseaseTypeRespValues = (
  configUrl: string,
  diseaseIdentifier: string
) =>
  API.getMaster(
    `${configUrl}api/master/IcdDiagnosisType?searchText=${diseaseIdentifier}`
  );

export const GetDisciplineRequestorMaster = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/DisciplineRequestor`);

export const GetClinicalGroup = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/GetClinicalGroup`);

export const GetEligibilityHealthPlan = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/EligibilityHealthPlan`);

export const GetEligibilityRecord = (
  configUrl: string,
  benefitPlanUid: string
) =>
  API.getMaster(
    `${configUrl}api/master/BenefitPlanUid?benefitPlanUid=${benefitPlanUid}`
  );

export const GetNotesApprovalStatusMaster = (configUrl: string) =>
  API.getMaster(`${configUrl}api/approvalStatus`);

export const GetHealthPlanMaster = (configUrl: any, filter?: string) =>
  API.getMaster(`${configUrl}api/master/HealthPlan${filter || ""}`);

export const GetBenefitPlanDetailsMaster = (
  configUrl: string,
  healthPlanId: number,
  state: string
) => API.getMaster(`${configUrl}api/master/BenefitPlanDetails/${healthPlanId}?healthPlanState=${state}`);

export const GetBenefitPlanStatesMaster = (
  configUrl: string
) => API.getMaster(`${configUrl}api/master/GetBenefitPlanStates`);

export const GetAllServiceStatusReasonMaster = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/StatusReasons`);

export const GetNtuReasonMaster = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/NtuStatusReason`);
export const GetLanguageMaster = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/Language`);

export const GetAccomodationMaster = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/Accommodation`);

export const GetAgencyCommunicationTemplate = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/AgencyTemplate`);

export const GetAuthorizationType = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/AuthorizationType`);

export const GetFaxForm = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/FaxForm`);

export const GetFaxFormOption = (configUrl: string, formId: number) =>
  API.getMaster(`${configUrl}api/master/FaxFormOption/${formId}`);

export const GetLetterCopyTypeMaster = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/GetTypeIdAsync`);

export const GetServiceRequestNumberMaster = (
  configUrl: string,
  referralId: number
) => API.getMaster(`${configUrl}api/master/ServiceRequestId/${referralId}`);

export const GetReferralMgmtSystem = (configUrl: string) =>
  API.getMaster(`${configUrl}api/master/ReferralManagementSystem`);

export const GetNPPESDetailsData = (
  configUrl: string,
  payload: NppesPayloadData
) =>
  API.getMaster(
    `${configUrl}api/master/NppesSearch/Results?${GetQueryString(payload)}`
  );

export const MasterSyncApi = (configUrl: string, payload: MasterSync[]) =>
  API.postApi(`${configUrl}api/master/UpdatedMasterApi`, payload);

export const GetServiceRequestDisciplines = (configUrl: string, serviceRequestId: number) =>
  API.getMaster(`${configUrl}api/master/ServiceRequestDisciplineId/${serviceRequestId}`);

export const GetCreatedByUsers = (configUrl: string, referralId: string, type: string) =>  
  API.get(`${configUrl}api/master/UserDetailsForFilter?referralId=${referralId}&type=${type}`, true);

export const GetRelationshipTypeMaster = (
  configUrl: string
) => API.getMaster(`${configUrl}api/master/RelationshipType`);

export const GetServiceStatusTypeMaster = (
  configUrl: string,
) =>
  API.getMaster(
    `${configUrl}api/master/ReferralServiceStatus`
  );